export default __webpack_public_path__ + "static/media/Correcto.b78a1bb3.png";